module.exports = __webpack_public_path__ + "static/media/error.9f456173.wav";